import { render, staticRenderFns } from "./PeopleIcons.vue?vue&type=template&id=1cc39394"
import script from "./PeopleIcons.vue?vue&type=script&lang=ts"
export * from "./PeopleIcons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports